export enum AnalyticsDataEventObject {
  REPORT = 'report',
  VIEW = 'view',
  COPY_VIEW_URL = 'copy_view_url',
  POPOUT = 'popout',
  BETA_FEEDBACK = 'beta_feedback',
  BETA_FEEDBACK_COMMENT = 'beta_feedback_comment',
  VIEW_IN_INBOX = 'view_in_inbox',
  GROUP_BY = 'group_by',
  NO_COMPARISON = 'no_comparison',
  WORKLOAD_TOUR = 'workload_tour',
  TABLE_ROW_LIST = 'table_row_list',
  CUSTOM_REPORT_ADD_CHART = 'add_chart_widget',
  ALL_REPORTS = 'all_reports',
  CREATE_CUSTOM_REPORT = 'create_custom_report',
  TEMPLATE_CATEGORY = 'template_category',
  VIEW_TEMPLATE = 'view_template',
  CREATE_FROM_TEMPLATE = 'create_from_template',
  SAVE_CUSTOM_REPORT = 'save_custom_report',
  EDIT_CUSTOM_REPORT = 'edit_custom_report',
  DELETE_CUSTOM_REPORT = 'delete_custom_report',
  CUSTOM_REPORT_EDIT_CHART = 'edit_chart_widget',
  CUSTOM_REPORT_DUPLICATE_CHART = 'duplicate_chart_widget',
  CUSTOM_REPORT_DELETE_CHART = 'delete_chart_widget',
  CUSTOM_REPORT_MOVE_CHART = 'move_chart_widget',
  CUSTOM_REPORT_CHART_TYPE = 'widget_type',
  CUSTOM_REPORT_ADD_OPTION = 'widget_add_option',
  CUSTOM_REPORT_REMOVE_OPTION = 'widget_delete_option',
  CUSTOM_FIELD_CUSTOM_REPORT_TABLE_METRICS_TIP = 'custom_field_custom_report_table_metrics_tip',
  V4_BETA_FEEDBACK = 'v4_beta_feedback',
  V4_BETA_FEEDBACK_COMMENT = 'v4_beta_feedback_comment',
}
